import { ComponentProps, forwardRef } from 'react'

import NextLink from 'next/link'

export const Link = forwardRef<
  HTMLAnchorElement,
  ComponentProps<typeof NextLink>
>((props, ref) => {
  return (
    <NextLink
      {...props}
      rel={
        props.rel ??
        (props.target === '_blank' ? 'noopener noreferrer' : undefined)
      }
      prefetch={props.prefetch ?? false}
      {...(!!ref && { ref })}
    />
  )
})
